export const INLINE_LOADED = 'INLINE_LOADED';
export const INLINE_LOADED_RESET = 'INLINE_LOADED_RESET';
export const INLINE_VALIDATION_RESULT = 'INLINE_VALIDATION_RESULT';
export const INLINE_ADD_VALIDATION_LISTENER = 'INLINE_ADD_VALIDATION_LISTENER';
export const INLINE_REMOVE_VALIDATION_LISTENER = 'INLINE_REMOVE_VALIDATION_LISTENER';
export const INLINE_VALIDATE_RESULT = 'INLINE_VALIDATE_RESULT';

export const inlineLoaded = (widgetRef) => (dispatch) => {
  dispatch({
    type: INLINE_LOADED, value: widgetRef
  })
};

export const inlineValidate = (validationResult) => (dispatch) => {
  dispatch({
    type: INLINE_VALIDATION_RESULT, value: validationResult
  })
};

export const inlineValidateResult = (validateResult) => (dispatch) => {
  dispatch({
    type: INLINE_VALIDATE_RESULT, value: validateResult
  })
};

export const inlineAddValidationListener = () => (dispatch) => {
  dispatch({
    type: INLINE_ADD_VALIDATION_LISTENER
  })
};

export const inlineRemoveValidationListener = () => (dispatch) => {
  dispatch({
    type: INLINE_REMOVE_VALIDATION_LISTENER
  })
}



// WEBPACK FOOTER //
// ./src/inline/InlineActions.js